import { usingGet, usingPost } from '@ocean/api'

export const getWartsilaEndUserDeclarationConfirmation = () =>
  usingGet('SimulatorTrainings/GetWartsilaEndUserDeclarationConfirmation')

export const getWartsilaEndUserDeclaration = () =>
  usingGet('SimulatorTrainings/GetWartsilaEndUserDeclaration')

export const confirmWartsilaEndUserDeclaration = () =>
  usingPost('SimulatorTrainings/ConfirmWartsilaEndUserDeclaration', {})
